import Player from "@/components/LottiePlayer";
const features = [
  {
    title: "ASSESS YOUR DATA LANDSCAPE",
    text: "Our team works with you to evaluate your data management maturity level and appraise your existing systems, pinpointing strengths, weaknesses, and areas for improvement.",
    icon: "/assets/icons/flow-chart.json",
  },
  {
    title: "DEFINE YOUR DATA GOALS",
    text: "You tell us your area of need, your organization's specific objectives, and the data you want to publish, and we work together to align your data goals with your business objectives. ",
    icon: "/assets/icons/sign.json",
  },
  {
    title: "REQUIREMENT ANALYSIS",
    text: "We conduct a thorough analysis of your requirements and identify the necessary features, customizations, and integrations.",
    icon: "/assets/icons/magnify.json",
  },
  {
    title: "TAILORED CUSTOMIZATION",
    text: "We work with you to customize and personalize your solution. This can include adding data visualization tools, advanced data visualizations and features such as data versioning, secure data sharing, etc.",
    icon: "/assets/icons/stationery.json",
  },
  {
    title: "IMPLEMENT DATA GOVERNANCE & COMPLIANCE",
    text: "We work closely with you to integrate your data, boosting accessibility across your organization and empowering teams to collaborate more effectively.",
    icon: "/assets/icons/verified-3.json",
  },
    {
    title: "OPTIMIZE DATA INTEGRATION, ACCESSIBILITY & COLLABORATION",
    text: "We work closely with you to integrate your data, boosting accessibility across your organization and empowering teams to collaborate more effectively.",
    icon: "/assets/icons/network.json",
  },
  {
    title: "TESTING, QUALITY ASSURANCE, AND DEPLOYMENT",
    text: "Our team conducts rigorous testing and quality assurance to ensure the solution is functioning optimally and meeting your requirements.",
    icon: "/assets/icons/complete.json",
  },
  {
    title: "CONTINUOUSLY MONITOR, ADAPT & EVOLVE",
    text: "We work closely with you to continuously monitor the progress of your data management initiatives and optimize your data strategy.",
    icon: "/assets/icons/connection.json",
  },
  {
    title: "ONGOING SUPPORT & PARTNERSHIP",
    text: "Our commitment to your success doesn't end with implementation. We provide ongoing support, resources, and partnership to help you leverage your data management solution effectively.",
    icon: "/assets/icons/handshake.json",
  },

]

export default function HowItWorks() {
  
  return (
    <section className="my-16 flex flex-col items-center justify-center md:py-12 bg-white bg-center font-['Inter']">
      <div className="xl:max-w-7xl lg:max-w-5xl md:max-w-3xl container px-8 " tabIndex={0}>
        <div className="text-center text-maingray">
          <h3 className="mb-8 text-4xl md:text-5xl tracking-tight leading-tight font-bold md:leading-tight">
            How it works
          </h3>
          <p className="body-text mb-16 xl:mb-24 mx-auto  max-w-4xl">
            Experience a perfect blend of professional insights and cutting-edge technology, as our team guides you from in-depth analysis to continuous support. Our expert-driven, step-by-step approach guarantees a customized solution that elevates your organization&apos;s data management to new heights. 
          </p>
        </div>
      </div>
      <div className="xl:max-w-7xl lg:max-w-5xl md:max-w-3xl grid grid-cols-1 lg:grid-cols-3 gap-14 px-4">
        {features.map((feature) => (
            <div key={feature.title}tabindex={0} className="p-16 flex flex-col items-center text-center rounded-3xl shadow-lg transition ease-in-out hover:shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] ">
              <Player
                autoplay
                loop
                src={feature.icon}
                style={{ height: "80px", width: "80px" }}
              />
              <h3 className="font-['Inter'] text-xl font-bold text-orange-400  py-2"> {feature.title} </h3>
              <p className="body-text"> {feature.text} </p>
            </div>
        ))}
      </div>
    </section>
  );
}


